import { ContractChangeValidationListFragment } from '../../../../types'
import { getUndefinedContractChangeValuesForGivenMonth } from './validationHelpers'

export type BonusChangeValidationType = {
  valid: boolean
  minimalValidValue?: number
}

export const bonusChangeValidation = (
  date: Date,
  bonus: number,
  contractChangeValidationList: ContractChangeValidationListFragment,
): BonusChangeValidationType => {
  const minimalValidValue: number = getUndefinedContractChangeValuesForGivenMonth(date, contractChangeValidationList).bonus
  if (bonus <= minimalValidValue) {
    return {
      valid: false,
      minimalValidValue: minimalValidValue,
    }
  }

  return { valid: true }
}
